var EN_TRANSLATION = {
  "footer.copyright": "Ubiquiti, Inc. All rights reserved.",
  "footer.header.buy": "Buy Now",
  "footer.header.company": "Company",
  "footer.header.social": "Social",
  "footer.header.terms": "Terms",
  "footer.header.tools": "Tools",
  "footer.header.training": "Training",
  "footer.link.becomeTrainer": "Become a Trainer",
  "footer.link.blog": "Blog",
  "footer.link.calendar": "Calendar",
  "footer.link.careers": "Careers",
  "footer.link.caseStudies": "Case Studies",
  "footer.link.compliance": "Compliance",
  "footer.link.contact": "Contact Us",
  "footer.link.courses": "Courses",
  "footer.link.designCenter": "UniFi Design Center",
  "footer.link.distributor.become": "Become a Distributor",
  "footer.link.distributor.find": "Find a Distributor",
  "footer.link.downloads": "Downloads",
  "footer.link.investors": "Investors",
  "footer.link.legal": "Legal",
  "footer.link.store": "Ubiquiti Store",
  "footer.link.terms.conditions": "Terms and Conditions",
  "footer.link.terms.cookie": "Cookies Settings",
  "footer.link.terms.faq": "FAQ",
  "footer.link.terms.policy.privacy": "Privacy Policy",
  "footer.link.terms.policy.return": "Return Policy",
  "footer.link.terms.service": "Terms of Service",
  "footer.link.trainers": "Trainers",
  "footer.link.trustCenter": "Trust Center",
  "footer.link.uisp": "UISP",
  "footer.link.uispDesignCenter": "UISP Design Center",
  "footer.link.wifiman": "WiFiman",
  "footer.newsletter.email": "Email",
  "footer.newsletter.error": "An error occurred, please try again later.",
  "footer.newsletter.error.invalidEmail": "Please enter a valid email address.",
  "footer.newsletter.error.missingEmail": "Please enter a valid email address.",
  "footer.newsletter.error.tooManyRequests": "Too many requests, please try again later.",
  "footer.newsletter.subscribe": "Subscribe",
  "footer.newsletter.success": "Thank you for subscribing!",
  "footer.newsletter.touch": "Stay in Touch",
  "footer.support": "Support",
  "footer.whats-new": "What's New"
};
export { EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
